export const primary = 'Nike TG, Helvetica Neue, Helvetica, Arial, sans-serif';
export const secondary = 'Helvetica Neue, Helvetica, Arial, sans-serif';
export const alternative = 'Nike Futura, Helvetica, Arial, sans-serif';
